import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminAPI, User } from '../api/api';
import Navbar from './Navbar';
import './UsersList.css';

const UsersList: React.FC = () => {
  const [users, setUsers] = useState<User[]>([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        const data = await adminAPI.getAllUsers();
        setUsers(data);
      } catch (error) {
        console.error('Ошибка при загрузке пользователей:', error);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const filteredUsers = users.filter(user => {
    if (!searchQuery.trim()) return true;
    const query = searchQuery.toLowerCase();
    return (
      user.username.toLowerCase().includes(query) ||
      user.email.toLowerCase().includes(query) ||
      (user.position && user.position.toLowerCase().includes(query))
    );
  });

  if (loading) {
    return (
      <>
        <Navbar />
        <div className="loading">Загрузка...</div>
      </>
    );
  }

  return (
    <>
      <Navbar />
      <div className="users-page-container">
        <div className="users-page-header">
          <h1>Сотрудники</h1>
          <p className="users-page-subtitle">
            Выберите сотрудника, чтобы посмотреть его загрузку и поставить задачу
          </p>
          <div className="users-search-container">
            <input
              type="text"
              placeholder="Поиск по сотрудникам..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="search-input"
            />
          </div>
        </div>
        <div className="users-grid">
          {filteredUsers.length === 0 ? (
            <div className="empty-state">
              <p>
                {searchQuery.trim() 
                  ? `Не найдено сотрудников по запросу "${searchQuery}"` 
                  : 'Нет сотрудников'}
              </p>
            </div>
          ) : (
            filteredUsers.map((user) => (
            <div
              key={user.id}
              className="user-card clickable"
              onClick={() => navigate(`/users/${user.id}`)}
            >
              <div className="user-avatar-circle">
                {user.username
                  .split(' ')
                  .map((p) => p[0])
                  .join('')
                  .toUpperCase()
                  .slice(0, 2)}
              </div>
              <div className="user-main">
                <div className="user-name">
                  {user.username}
                </div>
                <div className="user-email">{user.email}</div>
                <div className="user-role">
                  {user.position || 'Без должности'}
                </div>
              </div>
            </div>
            ))
          )}
        </div>
      </div>
    </>
  );
};

export default UsersList;


